import { render, staticRenderFns } from "./balanceAccounts.vue?vue&type=template&id=710807a6&scoped=true&"
import script from "./balanceAccounts.vue?vue&type=script&lang=js&"
export * from "./balanceAccounts.vue?vue&type=script&lang=js&"
import style0 from "./balanceAccounts.vue?vue&type=style&index=0&id=710807a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710807a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('710807a6', component.options)
    } else {
      api.reload('710807a6', component.options)
    }
    module.hot.accept("./balanceAccounts.vue?vue&type=template&id=710807a6&scoped=true&", function () {
      api.rerender('710807a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/balanceAccounts.vue"
export default component.exports